var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"start-window"},[_c('div',{staticClass:"b21"},[_vm._v(_vm._s(_vm.$t('USR_SAV'))+"...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }